import React, { useEffect, useState } from 'react'
import { CCol } from '@coreui/react'
import "../style.scss"
import { CommaSeparator, enToPersianChar } from '../../../../components/helper'
import { t } from 'i18next'
import { CheckIconSVG } from '../../../../components/IconSvg'
import { useTranslation } from 'react-i18next'
import FeaturesTranslate from './featuresTranslate'
import { useLocation, useParams } from 'react-router-dom'

const PackageItem = ({
    selected = false,
    packageTypeTitleEn,
    features = [],
    durations = [],
    isActive,
    selectItem,
    id,
    handleActivePackage,
    activePackagePending,
    idActiveClick,
    faDescription,
    enDescription, packageTypeTitleFa, duration
}) => {
    const { t, i18n } = useTranslation()
    let direction = i18n.dir()
    const [more, setMore] = useState(false)
    const location = useLocation();
    const params = useParams()

    // useEffect(() => {
    //     if (params) {

    //         console.log('test', params)
    //         console.log('id',id)
    //     }

    // }, [params])


    const periodConvertor = (type, currency) => {
        switch (type) {
            case "Month":
                if (currency === "IRR") {
                    return "در ماه"
                } else {
                    return "/ " + type
                }
            case "Year":
                if (currency === "IRR") {
                    return "در سال"
                } else {
                    return "/ " + type
                }
            case "Day":
                if (currency === "IRR") {
                    return "در روز"
                } else {
                    return "/ " + type
                }

            default:
                return "---"
        }
    }

    const featureRenderAllow = (title, count) => {

        if (title.indexOf("Domain") > -1) {
            return true
        }
        if (title.indexOf("OccuranceCall") > -1 && count > 0) {
            return true
        }

        if (title.indexOf("CallQueue") > -1 && count > 0) {
            return true
        }
        if (title.indexOf("CallReport") > -1) {
            return true
        }
        if (title.indexOf("CallStorageDuration") > -1 && count > 0) {
            return true
        }
        if (title.indexOf("CallInternalCallQueue") > -1 && count > 0) {
            return true
        }
        if (title.indexOf("SupportType") > -1 && count > 0) {
            return true
        }
        if (title.indexOf("InternalCall") > -1 && count > 0) {
            return true
        }


        return false
    }
    const handleCheckFavorite = () => {
        if (features.some(i => i.titel.indexOf("Favorite") > -1)) {
            const idx = features.findIndex(i => i.titel.indexOf("Favorite") > -1)
            if (features[idx].count > 0) {
                return true
            }
        }
        return false

    }



    const handlePackagePrice = () => {

        if (durations[0]?.priceAmounts[0]?.currency === "IRR") {
            if (durations[0]?.priceAmounts[0]?.price > 0) {
                return enToPersianChar(CommaSeparator((durations[0]?.priceAmounts[0]?.price / 10)))
            }
            if (durations[0]?.priceAmounts.length === 0 || durations[0]?.priceAmounts[0]?.price === 0) {
                return t('FREE_PACKAGE')
            }
        } else {
            if (durations[0]?.priceAmounts[0]?.price) {
                return CommaSeparator(durations[0]?.priceAmounts[0]?.price)
            }
            if (durations[0]?.priceAmounts.length === 0) {
                return t('FREE_PACKAGE')
            }
        }
    }


    const CreateDisplayFeatures = () => {

        return features.filter(f => featureRenderAllow(f?.titel, f.count))

    }

    const showMemberCount = () => {
        let count
        features.forEach((item) => {
            if (item.titel === "Member Count") count = item?.count
        })
        return count ? i18n.dir() === 'rtl' ? enToPersianChar(count) + 'همکار' : count + 'Collegue' : ''
    }



    return (
        <div id="slider-card" className={`slider-card-view ${(location?.state?.packageId === id || ((localStorage.getItem("pathPackageReference") === '' || localStorage.getItem("pathPackageReference") === null) && params?.id === id)) ? 'selected' : ''}`}>
            <div className='d-flex flex-row justify-content-between'>
                <div className='item-head'>
                    {i18n.language === 'fa' && packageTypeTitleFa ? packageTypeTitleFa : i18n.language === 'fa' && !packageTypeTitleFa ? '----' :
                        i18n.language === 'en' && packageTypeTitleEn ? packageTypeTitleEn : i18n.language === 'fa' && !packageTypeTitleEn ? '----' : ''
                    } </div>
                {handleCheckFavorite() && <div className='favorite-item' >
                    {t("TITLE.FAVORITE_TITLE")}
                </div>}

            </div>
            <div>
                {durations.length > 0 &&
                    <div className='d-flex flex-row justify-content-center'>
                        {/* {durations[0]?.priceAmounts.length > 0 && durations[0]?.priceAmounts[0]?.price > 0 &&
                            <span className='price-unit'> {t("PACKGE.MONTHLY")}/</span>} */}
                        <span className='price-number'>
                            {handlePackagePrice()}
                        </span>
                        <span className='price-unit'>
                            {durations[0]?.priceAmounts[0]?.price ? durations[0]?.priceAmounts[0]?.currency === "IRR" ? " هزار تومان " : "$" : ''}
                        </span>
                        {/* <span>
                                 {periodConvertor(durations[0]?.title, durations[0]?.priceAmounts[0]?.currency)}
                             </span> */}
                    </div>
                }
            </div>
            <div className='d-flex flex-row justify-content-center package-description'>
                {i18n.language === 'fa' && faDescription ? faDescription : i18n.language === 'en' && enDescription ? enDescription : ''}
            </div>
            <div className='d-flex flex-row justify-content-center'>
                {isActive ? <button className='btn btn-primary acive-packege-btn'
                    disabled={activePackagePending}
                    onClick={() => { handleActivePackage(features, durations, id) }}>
                    {
                        activePackagePending && idActiveClick === id ?
                            <div className="spinner-border" role="status" aria-hidden="true"></div>
                            :

                            t('ACTIVE_PACKAGE')}</button> :
                    <button className='btn btn-default acive-packege-btn' >
                        {t('TITLE.SOON')}</button>
                }
            </div>
            {/* <hr className='hr-packege' /> */}
            <span className='m-2 d-flex justify-content-start align-items-center count-member'>{showMemberCount()}</span>
            <div className='d-flex flex-row justify-content-start feauter-package'>
                {t('FEAUTER_OF_PACKEGE')}{' '}{i18n.language === 'fa' && packageTypeTitleFa ? packageTypeTitleFa : i18n.language === 'fa' && !packageTypeTitleFa ? '----' :
                    i18n.language === 'en' && packageTypeTitleEn ? packageTypeTitleEn : i18n.language === 'fa' && !packageTypeTitleEn ? '----' : ''
                }
            </div>
            <div className='description'>
                <ul>
                    {CreateDisplayFeatures().map((f, idx) => {
                        if (idx < 6 || more) {
                            return (<div key={idx} className='d-flex  flex-row justify-content-start align-items-center'>
                                <span className='icon-title'>
                                    <img src={f?.iconUrl} />
                                </span>
                                <FeaturesTranslate feature={f} />
                            </div>)
                        } else {
                            return null
                        }

                    })}

                    {CreateDisplayFeatures().length > 6 && !more && <div className='more-button' onClick={() => setMore(true)}>موارد‌ بیشتر</div>}

                </ul>
            </div>
        </div>
    )
}

export default PackageItem

